import React, { useState } from 'react';
import { Card, Form, Select } from 'antd';

export interface WarningCardConfig {
    fields: string[];
}

const DEFAULT_WARNING_CARD_CONFIG: WarningCardConfig = {
    fields: [],
};

interface Props {
    initialConfig?: Partial<WarningCardConfig>;
    fieldOptions?: Array<{ label: string; value: string }>;
    onChange: (config: WarningCardConfig) => void;
}

export const SectionConfigWarningCard: React.FC<Props> = ({ initialConfig, fieldOptions, onChange }) => {
    const [config, setConfig] = useState<WarningCardConfig>({
        ...DEFAULT_WARNING_CARD_CONFIG,
        ...initialConfig,
    });

    const updateField = (field: keyof WarningCardConfig, value: any) => {
        const newConfig = { ...config, [field]: value };
        setConfig(newConfig);
        onChange(newConfig);
    };

    return (
        <Card size="small" style={{ background: '#f5f5f5' }}>
            <Form.Item label="Aggregations to check">
                <Select
                    mode="multiple"
                    allowClear
                    options={fieldOptions || []}
                    value={config.fields}
                    onChange={(vals) => updateField('fields', vals)}
                />
            </Form.Item>
        </Card>
    );
};

export default SectionConfigWarningCard;
